// extracted by mini-css-extract-plugin
module.exports = {"slide-in":"slide-in_slide-in__3B1He"};